import { useCallback, useEffect, useRef, useState } from 'react';

/*
    🔥 CONTROL DE UN POPOVER

    Devuelve lo mismo que useModal más el ref del disparador, que es lo
    que AppPopover necesita para saber dónde ubicarse.

        const pop = usePopover();

        <button ref={pop.anchorRef} onClick={pop.toggle}>Acciones</button>

        <AppPopover isOpen={pop.isOpen} onClose={pop.close} anchorRef={pop.anchorRef}>
            …
        </AppPopover>
*/

export const usePopover = (initial = false) => {

    const [useIsOpen, setIsOpen] = useState(initial);
    const [usePayload, setPayload] = useState(null);

    const REF__anchorRef = useRef(null);

    const CB__open = useCallback((payload = null) => {
        setPayload(payload);
        setIsOpen(true);
    }, []);

    const CB__close = useCallback(() => setIsOpen(false), []);

    const CB__toggle = useCallback(() => setIsOpen((prev) => !prev), []);

    /*
        ⚠️ AL DESMONTARSE HAY QUE CERRAR

        Si el componente que lo abrió desaparece —una fila que se borra,
        una pestaña que cambia— el popover quedaría flotando en el
        portal sin dueño, imposible de cerrar salvo recargando.
    */
    useEffect(() => () => setIsOpen(false), []);

    return { isOpen: useIsOpen, payload: usePayload, anchorRef: REF__anchorRef, open: CB__open, close: CB__close, toggle: CB__toggle };
};
